import { put, retry, all } from 'redux-saga/effects';
import { authClient } from '../api/Client';
import { reject, resolve } from '../api';
import * as types from '../constants';
import {
  showNotification,
  simpleErrorNotification,
} from '../../shared-components/Notifications';

export function* loadAPIVersion() {
  try {
    const res = yield retry(4, 500, authClient?.Version.version);

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.VERSION),
        payload: res?.data(),
      });
    } else {
      yield all([
        put({
          type: reject(types?.VERSION),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'An error has occurred while getting version information.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.VERSION),
  //     payload: res?.data(),
  //   });
  // } catch (error) {
  //   yield put({
  //     type: reject(types?.VERSION),
  //     error,
  //   });
  // }
}
